import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { namespaceOf } from '@/i18n';
import { sectionHref, tabSections, type SectionDefinition } from '../registry';
import type { ClinicRole, StaffRole } from '../session/roles';
import s from '../layouts/Layout.module.css';

/**
 * Вкладки группы разделов над экраном (например, «Профиль · Офферы · Отзывы обо мне · Сообщество»).
 * Показываются, если ролям доступно больше одного раздела группы; текущий — aria-current.
 */
export function SectionTabs({ section, roles }: { section: SectionDefinition; roles: ReadonlyArray<ClinicRole | StaffRole> }) {
  const members = tabSections(section, roles);
  const keys = members.map((item) => item.tabTitleKey ?? item.titleKey);
  const { t, ready } = useTranslation(['shell', ...new Set(keys.map(namespaceOf))]);
  if (members.length === 0 || !ready || !section.tabGroup) return null;
  return (
    <nav className={s.sectionTabs} aria-label={t(`shell:tabGroups.${section.tabGroup}`)}>
      <ul className={s.sectionTabsList}>
        {members.map((item, index) => (
          <li key={item.id}>
            <Link to={sectionHref(item)} className={s.sectionTab} aria-current={item.id === section.id ? 'page' : undefined}>
              {t(keys[index] ?? item.titleKey)}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
